import { Skeleton, Stack, Text, useColorModeValue } from '@ecoinvent/ui';

import { CompareDatasetCard, DatasetRef } from 'components/shared/Compare';

import { useResolveCompareDataset } from './useResolveCompareDataset';

type Props = {
  datasetRef: DatasetRef;
};

const ComparisonCard = ({ datasetRef }: Props) => {
  const grayText = useColorModeValue('gray.500', 'gray.400');
  const { dataset, isLoading } = useResolveCompareDataset(datasetRef);

  if (dataset)
    return (
      <CompareDatasetCard dataset={dataset} to={`/${datasetRef.version}/${datasetRef.systemModel}/dataset/${datasetRef.id}`} />
    );

  if (isLoading) return <Skeleton height="180px" borderRadius="lg" />;

  return (
    <Stack borderWidth="1px" borderRadius="lg" p={4} justify="center" minH="180px">
      <Text color={grayText}>
        Dataset {datasetRef.id} could not be loaded from {datasetRef.version}-{datasetRef.systemModel}.
      </Text>
    </Stack>
  );
};

export default ComparisonCard;
